/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'react',
	'react-dom',
	'@ba/ba-ui-carbon-toolkit',
	'jquery',
	'../lib/@waca/core-client/js/core-client/ui/core/View'
], function(React, ReactDOM, toolkit, $, BaseView) {

	const { ProgressIndicator } = toolkit;
	class ExtensionBaseView extends BaseView {

		constructor(options){
			super(options);
		}

		init(options){
			super.init(options);
			this.containerNode = options.containerNode;
		}

		_setLoading() {
			ReactDOM.render(
				<ProgressIndicator variant='bar' />,
				this.containerNode
			);
		}

		_removeLoading() {
			ReactDOM.unmountComponentAtNode(this.containerNode);
		}

		remove(){
			super.remove();
		}
		/**
		 * Clear DOM node 
		 * 
		 * */
		static clearContainer (container){
			ReactDOM.unmountComponentAtNode(container);
			$(container).empty();
		}
	}

	ExtensionBaseView.CELL = {
		style:{
			left: {
				padding: '0px 8px',
				textAlign: 'left',
				width: '100%'
			},
			right: {
				padding: '0px 8px',
				textAlign: 'right',
				width: '100%'
			},
			center:{
				padding: '0px 8px',
				textAlign: 'center',
				width: '100%'
			}
		}
	};

	return ExtensionBaseView;
});